import { Accordion, Button } from "react-bootstrap";
import { useFormikContext } from "formik";

import { FareOperation } from "../../types/AddFare";
import { AddFareZone } from "../../types/AddFareZone";
import { EditFareZone } from "../../types/EditFareZone";
import { FareZone } from "../../types/FareZone";

import FareDisplay from "../fare/fareDisplay";
import FareEditor from "./FareEditor";

export interface FareZoneFormFaresTabProps {
  currentFareZone: FareZone | undefined;
  reviewMode: boolean;
  minEffectiveFrom: Date;
  suggestedEffectiveFrom: Date;
}

const FareZoneFormFaresTab = ({
  currentFareZone,
  reviewMode,
  minEffectiveFrom,
  suggestedEffectiveFrom,
}: FareZoneFormFaresTabProps) => {
  const { values, setFieldValue } = useFormikContext<
    AddFareZone | EditFareZone
  >();

  let today = new Date();
  today = new Date(
    Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()),
  );
  const pendingFare =
    currentFareZone &&
    currentFareZone.fares.find((f) => new Date(f.effectiveFrom) > today);
  const currentFare =
    currentFareZone &&
    currentFareZone.fares.find((f) => new Date(f.effectiveFrom) <= today);

  return (
    <>
      {currentFareZone && (
        <Accordion defaultActiveKey="current">
          <Accordion.Item eventKey="current">
            <Accordion.Header>Current Fares</Accordion.Header>
            <Accordion.Body>
              <FareDisplay fare={currentFare} showEffectiveFrom={true} />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="pending">
            <Accordion.Header>Pending Fare Change</Accordion.Header>
            <Accordion.Body>
              {!values.fare && (
                <>
                  <FareDisplay
                    fare={pendingFare}
                    showEffectiveFrom={true}
                    noFareMessage="No Pending Fare"
                  />
                  {!pendingFare && !reviewMode && (
                    <Button
                      size="sm"
                      onClick={() =>
                        setFieldValue("fare", {
                          ...(currentFare ?? {}),
                          effectiveFrom: suggestedEffectiveFrom.toJSON(),
                          operation: FareOperation.Add,
                        })
                      }>
                      New Fare
                    </Button>
                  )}
                  {pendingFare && !reviewMode && (
                    <Button
                      size="sm"
                      onClick={() =>
                        setFieldValue("fare", {
                          ...pendingFare,
                          operation: FareOperation.Edit,
                        })
                      }>
                      Edit Pending Fare
                    </Button>
                  )}
                </>
              )}
              <FareEditor minEffectiveFrom={minEffectiveFrom} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}
      {!currentFareZone && (
        <>
          <h6>Fare</h6>
          <FareEditor minEffectiveFrom={minEffectiveFrom} />
        </>
      )}
    </>
  );
};

export default FareZoneFormFaresTab;
